import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  columns: {
    path: string | null;
    label: string;
    key: string | null;
    // eslint-disable-next-line no-empty-pattern
    content: ({}) => Element | null;
  }[];
}

const TableHeader = ({ columns }: Props) => {
  return (
    <StyledTableHead>
      <tr>
        {columns.map(
          (column: {
            path: string | null;
            label: string;
            key: string | null;
            // eslint-disable-next-line no-empty-pattern
            content: ({}) => Element | null;
          }) => (
            <th align="left" key={column.path || column.key}>
              <div>{column.label}</div>
            </th>
          )
        )}
      </tr>
    </StyledTableHead>
  );
};

const StyledTableHead = styled.thead`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1rem;
  > tr > th {
    padding: 0;
  }
  > tr > th > div {
    padding: 1rem;
    color: ${Colors.eastBay};
    background: ${Colors.aliceBlue};
    border-top: 1px solid ${Colors.solitude};
    border-bottom: 1px solid ${Colors.solitude};
  }
  > tr > th:first-child > div {
    padding-left: 2rem;
    border-radius: 0.5rem 0 0 0.5rem;
    border: 1px solid ${Colors.solitude};
    border-right: none;
  }
  > tr > th:last-child > div {
    border-radius: 0 0.5rem 0.5rem 0;
    border: 1px solid ${Colors.solitude};
    border-left: none;
  }
`;

export default TableHeader;
